'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createAccount = require('./create-account');

var _createAccount2 = _interopRequireDefault(_createAccount);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CreateAccountTrigger = _react2['default'].createClass({
    displayName: 'CreateAccountTrigger',


    propTypes: {
        'key': _react2['default'].PropTypes.string,
        'linkText': _react2['default'].PropTypes.string,
        'trigger': _react2['default'].PropTypes.element,
        'triggerSelector': _react2['default'].PropTypes.string,
        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
        'buttonText': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'redirectUrl': _react2['default'].PropTypes.string,
        'signupUrl': _react2['default'].PropTypes.string,
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        if (window.handlingLogInTriggers) {
            // We only want to process this once per page
            return;
        }
        // If the 'login=1' URL parameter is present, display the modal
        if (/\?display_signup\=1|&display_signup\=1/i.test(location.href)) {
            window.handlingSignupTriggers = true;
            this.handleClick(null);
        }
    },

    handleClick: function handleClick(e) {
        if (e != null) {
            e.preventDefault();
        }
        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('create_account_modal');
        _reactDom2['default'].render(_jsx(_createAccount2['default'], {
            header: this.props.header,
            buttonText: this.props.buttonText,
            googleOpenIdUrl: this.props.googleOpenIdUrl,
            isFromApiPricing: this.props.isFromApiPricing,
            tabOffset: tabOffset,
            redirectUrl: this.props.redirectUrl,
            signupUrl: this.props.signupUrl,
            signupForm: this.props.signupForm,
            loginForm: this.props.loginForm,
            recoverPasswordForm: this.props.recoverPasswordForm,
            hideRememberMe: this.props.hideRememberMe
        }), attachPoint);
    },

    renderTrigger: function renderTrigger() {
        if (this.props.triggerSelector) {
            return _jsx(DOMElementWrapper, {
                element: this.props.triggerSelector
            });
        } else if (this.props.trigger) {
            return this.props.trigger;
        } else {
            return _jsx('a', {
                href: '#'
            }, void 0, this.props.linkText);
        }
    },

    render: function render() {
        var trigger = this.renderTrigger();
        return _react2['default'].createElement(
            'span',
            { ref: 'signUpTrigger', className: 'sign-up-trigger', onClick: this.handleClick },
            trigger
        );
    }
});

var DOMElementWrapper = _react2['default'].createClass({
    displayName: 'DOMElementWrapper',

    componentDidMount: function componentDidMount() {
        var signUpTrigger = this.refs.container;
        signUpTrigger.appendChild($(this.props.element)[0]);
    },
    render: function render() {
        return _react2['default'].createElement('span', { ref: 'container' });
    }
});

module.exports = CreateAccountTrigger;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account-trigger.jsx
 ** module id = 759
 ** module chunks = 0
 **/